import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Components
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ResetPasswordChangeComponent } from './components/reset-password-change/reset-password-change.component';

import { AuthIconsService } from './services/auth.icons.service';
import { LoadingComponent } from '@app/shared/components/loading/loading.component';
import { RemoveIconComponent } from '@app/shared/components/icons/generated/remove/remove.component';
import { View1IconComponent } from '@app/shared/components/icons/generated/view-1/view-1.component';
import { ViewOffIconComponent } from '@app/shared/components/icons/generated/view-off/view-off.component';
import { ArrowLeft1IconComponent } from '@app/shared/components/icons/generated/arrow-left-1/arrow-left-1.component';
import { CheckEmailIconComponent } from '@app/shared/components/icons/generated/check-email/check-email.component';
import { NewPasswordIconComponent } from '@app/shared/components/icons/generated/new-password/new-password.component';

const COMPONENTS = [
  // Components
  SignInComponent,
  SignUpComponent,
  ResetPasswordComponent,
  ResetPasswordChangeComponent,
];

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    TranslocoModule,
    ReactiveFormsModule,
    RouterModule,

    // Popsy Modules
    LoadingComponent,

    // Icons
    RemoveIconComponent,
    View1IconComponent,
    ViewOffIconComponent,
    ArrowLeft1IconComponent,

    CheckEmailIconComponent,
    NewPasswordIconComponent,
    ...COMPONENTS,
  ],
  providers: [],
  exports: COMPONENTS,
})
export class AuthModule {
  constructor(private readonly authIconsService: AuthIconsService) {
    this.authIconsService.loadIcons();
  }
}
